import {
  PaginationData,
  SeedingBatch,
} from 'constants/interface';
import {
  buildPaginationParams,
  getPaginationHeaders,
  PaginatedResponse,
  requestClient,
} from 'infra/request';

interface ScheduleData {
  seedingDate: string
  greenhouse: string
  notes?: string
}

export interface UpdateSeedingScheduleData {
  id: string
  data: ScheduleData
}

export interface GetSeedingBatchList extends PaginationData {
  seedingDate?: string
}

export interface SeedingBatchApi {
  getSeedingBatch(seedingBatchId: string): Promise<SeedingBatch>
  getSeedingBatchList(filter: GetSeedingBatchList): Promise<PaginatedResponse<SeedingBatch>>
  updateSeedingSchedule(scheduleData: UpdateSeedingScheduleData): Promise<SeedingBatch>
  // updateSeedReservation(seedReservationData: UpdateSeedReservationData): Promise<SeedingBatch>
}

const seedingBatchApiBuilder = (): SeedingBatchApi => {
  const getSeedingBatch = async (
    seedingBatchId: string,
  ): Promise<SeedingBatch> => {
    const result = await requestClient.get(`/production-items/${seedingBatchId}`);
    const seedingBatch: SeedingBatch = result.data as SeedingBatch;
    return seedingBatch;
  };

  const getSeedingBatchList = async (
    filterData: GetSeedingBatchList,
  ): Promise<PaginatedResponse<SeedingBatch>> => {
    const params = buildPaginationParams(filterData);
    const result = await requestClient.get('/seeding-batches', params);
    const pagination = getPaginationHeaders(result);
    const productionItemList: SeedingBatch[] = result.data as SeedingBatch[];
    return {
      pagination,
      data: productionItemList,
    };
  };

  const updateSeedingSchedule = async (
    data: UpdateSeedingScheduleData,
  ): Promise<SeedingBatch> => {
    const { id: seedingBatchId, data: scheduleData } = data;
    const params: Record<string, unknown> = {
      ...scheduleData,
    };
    const result = await requestClient.put(`/seeding-batches/${seedingBatchId}/schedule`, params);
    const updatedSeedingBatch: SeedingBatch = result.data as SeedingBatch;
    return updatedSeedingBatch;
  };

  return {
    getSeedingBatch,
    getSeedingBatchList,
    updateSeedingSchedule,
    // updateSeedReservation,
  };
};

export const seedingBatchApi = seedingBatchApiBuilder();
